<div class="login-background">
    <div class="login-wrapper">

        <div class="login-logo"></div>
        <div class="login-title bold uk-margin-medium-top">v{{ release }}</div>
        <div class="login-env-flags">
            <span *ngIf="testMode" class="mode-label mode-label--red">TEST</span>
            <span *ngIf="devMode" class="mode-label mode-label--blue">DEV</span>
        </div>
        <div class="login-title bold uk-margin-medium-top">Se connecter</div>

        <form [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)">

            <div uk-grid class="uk-padding-remove">

                <div class="uk-width-1-1 uk-margin-large-top">
                    <div class="uk-margin">
                        <div class="uk-inline uk-width-9-10">
                            <input class="uk-input input" name="username" id="username" type="text"
                                formControlName="username" placeholder="Identifiant">
                        </div>
                    </div>

                    <div class="uk-margin">
                        <div class="uk-inline uk-width-9-10">
                            <input class="uk-input input" name="password" id="password" type="password"
                                formControlName="password" placeholder="Mot de passe">
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1 uk-margin-large-top">
                    <button class="uk-button button login-button" type="submit">
                        <span class="bold">Me connecter</span>
                    </button>
                </div>

                <div class="uk-width-1-1 uk-margin-large-top">
                    <div class="uk-button button register-button default">
                        <span class="uk-margin-small-right">Pas encore inscrit?</span><span class="bold link pointer"
                            [routerLink]="['/register']">S'enregistrer</span>
                    </div>
                </div>

            </div>

        </form>
    </div>

</div>